import { format, isValid, parse } from 'date-fns';

import { DEFAULT_DATE_FORMAT } from 'constants/common';

const API_DATE_FORMAT = 'yyyy-MM-dd';

export const NO_SCHOOL_PREFIX_FILTER = '__NO_PREFIX__';

export const formatActivationReportDateForApi = (
  displayDate: string,
): string | undefined => {
  const trimmedDate = displayDate.trim();

  if (!trimmedDate) {
    return undefined;
  }

  const parsedDate = parse(trimmedDate, DEFAULT_DATE_FORMAT, new Date());

  if (!isValid(parsedDate)) {
    return undefined;
  }

  return format(parsedDate, API_DATE_FORMAT);
};

export const buildSchoolCodeFilterParams = ({
  activationFrom,
  activationTo,
  schoolPrefix,
}: {
  activationFrom: string;
  activationTo: string;
  schoolPrefix: string;
}): { from?: string; to?: string; schoolPrefix?: string } => {
  const from = formatActivationReportDateForApi(activationFrom);
  const to = formatActivationReportDateForApi(activationTo);
  const trimmedPrefix = schoolPrefix.trim();

  const hasFilters = Boolean(from || to || trimmedPrefix);

  if (!hasFilters) {
    return {};
  }

  return {
    ...(from ? { from } : {}),
    ...(to ? { to } : {}),
    ...(trimmedPrefix ? { schoolPrefix: trimmedPrefix } : {}),
  };
};

export const buildActivationReportFileName = (
  from: string,
  to: string,
  schoolPrefix = '',
): string => {
  const fromPart = formatActivationReportDateForApi(from) ?? 'all';
  const toPart = formatActivationReportDateForApi(to) ?? 'all';

  if (schoolPrefix === NO_SCHOOL_PREFIX_FILTER) {
    return `promocode-activations-no-prefix-${fromPart}-${toPart}.xlsx`;
  }

  const trimmedPrefix = schoolPrefix.trim();

  if (trimmedPrefix) {
    const prefixSlug = trimmedPrefix.replace(/[/\\?%*:|"<>]/g, '-');

    return `promocode-activations-${prefixSlug}-${fromPart}-${toPart}.xlsx`;
  }

  return `promocode-activations-${fromPart}-${toPart}.xlsx`;
};
